<div class="modal fade" id="myModalPolicesTerms" tabindex="9999" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="myModalLabel">Políticas de Privacidade e Termos de Uso</h4>
      </div>
      <div class="modal-body">
        <p>Para usufruir de todos os benefícios do nosso portal, precisamos que leia e aceite nossas
          <a (click)="readPoliciesAndTerms()">Políticas de Privacidade e Termos de Uso</a>.
        </p>

      </div>
      <div class="modal-footer">
        <div class="modal-footer-options">
          <div>
            <input type="checkbox" name="policiesAccepted" id="policiesAccepted" [(ngModel)]="policiesAccepted"> <label
              for="policiesAccepted">Li e aceito com as Políticas de Privacidade.</label>
          </div>
          <div>
            <input type="checkbox" name="termAccepted" id="termAccepted" [(ngModel)]="termAccepted"> <label
              for="termAccepted">Li e aceito os Termos de Uso.</label>
          </div>
        </div>

        <div class="modal-footer-button">
          <button type="button" class="btn btn-default app-btn-best" (click)="acceptTerms()"
            [disabled]="!policiesAccepted || !termAccepted">Aceitar</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="loading" class="text-center" style="margin-top: 1em;">
  <i class="fa fa-spinner fa-pulse fa-4x"></i>
  <p>Carregando...</p>
</div>


// WEBPACK FOOTER //
// ./src/app/politica-termo/modal-politica-termo/modal-politica-termo.component.html